/**
 * The columns every assignment table shares, then the value column each
 * dimension adds. One list covers all five: a projection keeps only the keys the
 * row actually carries, so a topic assignment yields `topicId` and nothing
 * else, while a relationship yields both of its own.
 *
 * `isNegation` and `runId` are in both sets: a correction is a row rather than
 * an edit, so a list that omitted them would render a withdrawal exactly like
 * the assertion it withdraws.
 */
const sharedAttributes = [
  'id',
  'questionId',
  'runId',
  'source',
  'isNegation',
  'confidence',
  'assignedBy',
  'createdAt',
] as const;

const valueAttributes = [
  'topicId',
  'questionTypeId',
  'directiveVerbId',
  'scaleId',
  'value',
  'relatedQuestionId',
  'relationshipTypeId',
] as const;

const getAttributes = [...sharedAttributes, ...valueAttributes] as const;

const listAttributes = [
  'id',
  'questionId',
  'runId',
  'source',
  'isNegation',
  'confidence',
  'createdAt',
  ...valueAttributes,
] as const;

export const QuestionCategorisationAttributes = {
  Get: getAttributes,
  List: listAttributes,
};
